function attachSwatchListeners() {
  const productCards = document.querySelectorAll(".product-card-wrapper");

  productCards.forEach((card) => {
    const swatches = card.querySelectorAll(".js-swatch");
    const mainImage = card.querySelector("[data-featured-image]");

    if (!mainImage || !swatches.length) return;

    swatches.forEach((swatch) => {
      swatch.addEventListener("click", () => {
        const newImageUrl = swatch.getAttribute("data-img");
        const newProductUrl = swatch.getAttribute("data-url");

        // Update main image
        if (newImageUrl) {
          mainImage.src = newImageUrl;
          mainImage.srcset = "";
        }

        // Update all product links in the card
        if (newProductUrl) {
          card.querySelectorAll('a.full-unstyled-link, a.no-underline').forEach(link => {
            link.setAttribute('href', newProductUrl);
          });
        }

        // Update swatch active state
        swatches.forEach(s => s.classList.remove("current"));
        swatch.classList.add("current");
      });
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  attachSwatchListeners();
});

